//example: 1234567.89 will be formated to 1,234,567.89
export const formatNumber = (num: number): string => {
  const formatted = num.toLocaleString('en-US')
  return formatted
}

export const formatInSingleUnit = (number: number) => {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(number)
}
